import { render, staticRenderFns } from "./lawyer_sever_list.vue?vue&type=template&id=a44baaf6&scoped=true"
import script from "./lawyer_sever_list.vue?vue&type=script&lang=js"
export * from "./lawyer_sever_list.vue?vue&type=script&lang=js"
import style0 from "./lawyer_sever_list.vue?vue&type=style&index=0&id=a44baaf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44baaf6",
  null
  
)

export default component.exports